import PropTypes from 'prop-types'

import IconArrowRight from '@adv-mt/mt-svg-icons/lib/ArrowRightDefault.js'
import {Icon, ICON_INTENTS, ICON_SIZES} from '@adv-mt/ui/icon'
import {Body1, Subhead1} from '@adv-mt/ui/typography'

import {BASE_CLASS as PAGE_BASE_CLASS} from '../../../config.js'

const BASE_CLASS = `${PAGE_BASE_CLASS}-advantages-card`

const AdvantageCard = ({href, onClick, title, description, children}) => (
  <a className={BASE_CLASS} href={href} onClick={onClick} rel="noopener noreferrer" target="_blank">
    <div className={`${BASE_CLASS}-content`}>
      <div className={`${BASE_CLASS}-text`}>
        <Subhead1 as="h3">{title}</Subhead1>
        <Body1>{description}</Body1>
      </div>
      {children}
    </div>

    <span className={`${BASE_CLASS}-arrow`}>
      <Icon size={ICON_SIZES.MD} intent={ICON_INTENTS.PRIMARY}>
        <IconArrowRight size={ICON_SIZES.MD} />
      </Icon>
    </span>
  </a>
)

AdvantageCard.displayName = 'AdvantageCard'

AdvantageCard.propTypes = {
  href: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  children: PropTypes.node
}

export default AdvantageCard
